import { NgModule } from '@angular/core';
import { TopBarComponent } from './pricing-list/top-bar/top-bar.component';
import { ItemGridComponent } from './pricing-list/item-grid/item-grid.component';
import { PricingRoutingModule } from './pricing-routing.module';
import { ItemService, RestaurantService } from './services';
import { PricingListComponent } from './pricing-list/pricing-list.component';
import { BaseModule } from '@shared';

@NgModule({
  declarations: [TopBarComponent, ItemGridComponent, PricingListComponent],
  imports: [BaseModule, PricingRoutingModule],
  exports: [TopBarComponent, ItemGridComponent, PricingListComponent],
  providers: [ItemService, RestaurantService],
})
export class PrototypeProduct {}
